import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@achieve/ascend'
import { AchieveLink } from 'components/AchieveLink/AchieveLink'
import { Typography } from '../Contentful'

const ButtonCTA = ({ href, label, description, location }) => (
  <div
    className="flex flex-col w-full border border border-solid border-blue-100 rounded items-center my-4 md:my-8 md:pr-4 md:flex-row md:justify-between lg:pr-7"
    data-testid="buttonCTA"
    id="buttonCTA"
  >
    <div
      className={`bg-blue-50 w-full text-center py-10 px-14 md:px-0 md:text-left md:pl-4 lg:pl-8 md:w-4/5 md:[clip-path:polygon(0%_0%,85%_0,100%_100%,75%_100%,0%_100%)]`}
      data-testid="description wrapper"
    >
      <Typography content={description} className="bodyMd mb-0" />
    </div>

    <AchieveLink href={href} location={location} className="p-[50px] lg:p-0">
      <Button
        size="small"
        color="primary"
        variant="contained"
        data-testid="pfq-yes-button"
        className="min-w-[200px] bg-[#3d6feb]"
      >
        <Typography content={label} className="displayXs" />
      </Button>
    </AchieveLink>
  </div>
)

ButtonCTA.propTypes = {
  description: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  pageTypeName: PropTypes.string,
}

export default ButtonCTA
